import * as React from 'react';

import { List } from './styles';
import Item from '../../../../../containers/Editor/CombinePanel/SpreadsSelector/Grid/Item';

interface GridProps {
	spreads: number[][];
	onItemClick: (index: number, isCtrlPressed?: boolean, isShiftPressed?: boolean) => void;
}

const Grid = ({ spreads, onItemClick }: GridProps) => (
	<List>
		{spreads.map((spread, index) => (
			<Item
				key={spread[0]}
				spread={spread}
				spreadIndex={index}
				onClick={onItemClick}
			/>
		))}
	</List>
);

export default Grid;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/CombinePanel/SpreadsSelector/Grid/index.tsx